import React from "react";
import { Typography, Link, Box } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const options = [
  {
    name: "Terms of Use",
    path: "/api/resourceservice/termsOfUse",
  },
  {
    name: "Privacy Policy",
    path: "/api/resourceservice/privacyPolicy",
  },
];

function Footer() {
  const location = useLocation();
  return (
    <Box
      id="footer-id"
      sx={(theme) => ({
        padding: "10px 0",
        textAlign: "center",
        width: "100%",
      })}
    >
      <Typography
        sx={(theme) => ({
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "20px",
          letterSpacing: "0.5px",
          color: theme.textColour.headingColour,
        })}
      >
        ©{new Date().getFullYear()} Amalgam RX. All rights reserved.
        <br />
        <div>
          {location.pathname !== "/about" && (
            <Link
              component={RouterLink}
              to="/about"
              underline="none"
              sx={(theme) => ({
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                marginY: "5px",
                padding: "0 10px",
                color: "#1E88E5",
                display: "inline-block",
              })}
            >
              About AIMS Assessment{" "}
            </Link>
          )}
          {options.map((item) => {
            return (
              <Link
                key={item.name}
                target="_blank"
                component={RouterLink}
                to={item.path}
                underline="none"
                sx={(theme) => ({
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  letterSpacing: "0.5px",
                  marginY: "5px",
                  padding: "0 10px",
                  color: "#1E88E5",
                  display: "inline-block",
                })}
              >
                {item.name}
              </Link>
            );
          })}
        </div>
        Sponsored by Teva Neuroscience, Inc. TD-41765&nbsp;&nbsp;&nbsp;December
        2025
      </Typography>
    </Box>
  );
}
export default Footer;
